export default () => {
	if (
		window?.DDC?.dataLayer?.vehicles?.find?.((item) => {
			const vehicleImage = item.images[0];

			// vehicleImage can either be a string or an object
			const imageLink =
				typeof vehicleImage === 'object'
					? vehicleImage.uri
					: vehicleImage;

			return imageLink.includes('fd-FD_DEALERSERVICES_IMAGES');
		})
	) {
		return 'vinreal:vls';
	} else {
		return '';
	}
};
